<template>
  <div class="goods-card">
    <div class="goods-card-body">
      <div class="circle" />
      <img
        @click="goToProductInfo"
        class="card-img"
        :src="goodsVal.images[0].url"
        :alt="goodsVal.images[0].item_id"
      >
    </div>
    <div class="goods-card-footer">
      <div class="bg-decoration" />
      <div class="info">
        <span @click="goToProductInfo" class="category-name">{{ goodsVal.name }}</span>
<!--        <span class="brand-name">{{ goodsVal.brand_name }}</span>-->
<!--        <span class="model">{{ goodsVal.model }}</span>-->
<!--        <span class="features">{{ goodsVal.features }}</span>-->
      </div>
      <div class="buttons">
        <MtButton
          type="button"
          class="adding-btn goods-btn"
          @click="goToFeedback()"
        >
          <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
               viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
            <path d="M467,61H45C20.218,61,0,81.196,0,106v300c0,24.72,20.128,45,45,45h422c24.72,0,45-20.128,45-45V106
              C512,81.28,491.872,61,467,61z M460.786,91L256.954,294.833L51.359,91H460.786z M30,399.788V112.069l144.479,143.24L30,399.788z
               M51.213,421l144.57-144.57l50.657,50.222c5.864,5.814,15.327,5.795,21.167-0.046L317,277.213L460.787,421H51.213z M482,399.787
              L338.213,256L482,112.212V399.787z"/>
          </svg>
        </MtButton>
        <MtButton
          color="primary-invent"
          type="button"
          class="goto-btn goods-btn"
          @click="goToProductInfo"
        >
          <svg
            id="Capa_1"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            viewBox="0 0 31.49 31.49"
            style="enable-background:new 0 0 31.49 31.49;"
            xml:space="preserve"
          >
            <path
              d="M21.205,5.007c-0.429-0.444-1.143-0.444-1.587,0c-0.429,0.429-0.429,1.143,0,1.571l8.047,8.047H1.111
                C0.492,14.626,0,15.118,0,15.737c0,0.619,0.492,1.127,1.111,1.127h26.554l-8.047,8.032c-0.429,0.444-0.429,1.159,0,1.587
                c0.444,0.444,1.159,0.444,1.587,0l9.952-9.952c0.444-0.429,0.444-1.143,0-1.571L21.205,5.007z"
            />
          </svg>
        </MtButton>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import MtButton from '../MtButton/MtButton'

export default {
  name: 'GoodsCard',
  components: { MtButton },
  props: {
    goodsVal: Object
  },
  methods: {
    ...mapActions(['selectProduct']),
    goToFeedback () {
      this.selectProduct(this.goodsVal)
      this.$router.push({ path: `/feedback/${this.goodsVal.id}` })
    },
    goToProductInfo () {
      this.selectProduct(this.goodsVal)
      this.$router.push({ path: `/goods/info/${this.goodsVal.id}` })
    }
  }
}
</script>

<style scoped lang="scss">
  @import "../../vars";

  .goods-card {
    width: 250px;
    height: 310px;
    position: relative;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    border: 1px solid transparent;
    cursor: pointer;
    &:hover {
      .goods-card-body {
        .card-img {
          transform: translate(-50%, -50%) scale(1.05);
        }
        .circle {
          box-shadow: -2px 2px 8px -4px $btn-c;
        }
      }
    }
    .goods-card-body {
      height: 200px;
      position: relative;
      .circle {
        position: absolute;
        display: none;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        border-radius: 50%;
        height: 160px;
        width: 160px;
        box-shadow: -2px 2px 8px -4px #959595;
        z-index: 1;
      }
      .card-img {
        top: 55%;
        transform: translate(-50%, -50%);
        z-index: 2;
        transition: transform 0.2s ease;
        position: absolute;
        left: 50%;
        max-height: 80%;
        max-width: 80%;
      }
    }
    .goods-card-footer {
      display: flex;
      justify-content: space-between;
      flex: 1;
      position: relative;
      .bg-decoration {
        position: absolute;
        width: 100%;
        height: 60%;
        top: 20%;
        background-color: #fbfbfb;
      }
      .info, .buttons {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        position: relative;
      }
      .info {
        justify-content: center;
        flex: 1;
        box-sizing: border-box;
        padding-right: 10px;
        span {
          margin: 3px 0;
        }
        .category-name {
          font-weight: bold;
          text-align: left;
        }
        .brand-name, .model, .features {
          font-size: 12px;
        }
      }
      .buttons {
        justify-content: space-between;
        margin-right: 15px;
      }
    }
  }
  @media screen and (max-width: 550px){
    .goods-card {
      width: 100%;
    }
  }
</style>
